// src/slices/systemConfiguration/thunk.ts
// Async thunk cho System Configuration — chỉ giữ fetchSystemConfig (đọc cấu hình, dùng cho
// Cổng tra cứu kết quả). Không clone các thunk chỉnh sửa cấu hình (updateRegionConfig,
// updateLookupConfig...) vì không thuộc phạm vi 2 trang được clone.

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSystemConfig } from 'helpers/fakebackend_helper';

export const fetchSystemConfig = createAsyncThunk(
  'SystemConfiguration/fetchConfig',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getSystemConfig();
      return (response as any).data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || 'Có lỗi xảy ra khi tải cấu hình hệ thống'
      );
    }
  }
);
